import { Directive, OnInit, ElementRef, Input, EventEmitter, HostBinding, HostListener } from '@angular/core'

@Directive({
  selector: '[mpActivatableElement]'
})
export class ActivatableElementDirective implements OnInit {

  private static ACTIVE_CSS_CLASS: string = 'active'
  private activated: boolean = false

  constructor(private _element: ElementRef) {}

  @Input('mpActivatableElement') public mpActivatableElement: EventEmitter<ActivatableElementDirective>
  @HostListener('click') public onClick() {
    this.mpActivatableElement.emit(this)
  }

  public ngOnInit(): void {
    if (typeof this.mpActivatableElement !== 'undefined') {
      this.mpActivatableElement.subscribe((activeElement: ActivatableElementDirective) => {
        this._toggleActive(activeElement === this && !this.activated)
      })
    }
  }

  private _toggleActive(status: boolean): void {
    const mutatorFn = status ? 'add' : 'remove'
    this._element.nativeElement.classList[mutatorFn](ActivatableElementDirective.ACTIVE_CSS_CLASS)
    this.activated = status
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/directives/activatable-element.directive.ts